<project-dashboard-header
  [project]="project()"
  (toolDragStarted)="onToolDragStarted($event)"
  (toolDragEnded)="onToolDragEnded()"
  (stageChanged)="onStageChanged($event)"
/>

<project-dashboard-stepper
  [currentStage]="project()?.stage || null"
  [projectId]="project()?.id || null"
  [activeStep]="activeStep()"
  (stepSelected)="onStepSelected($event)"
/>

<div
  class="dashboard-container"
  [ngClass]="{
    'dashboard-container--configurator': isConfigPage()
  }"
>
  <router-outlet />
</div>

<project-dashboard-dock [draggedToolFromHeader]="draggedToolFromHeader()" [currentRoute]="currentRoute()" />
